import { Box, Grid, InputAdornment, TextField, Tooltip } from "@mui/material";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";
const SearchDocuments = ({ onChangeSearchHandller }) => {
  return (
    <Grid item xs={12} md={3} >
        <Tooltip title="Search Documents..." arrow >
        <TextField
          id="input-with-icon-textfield"
          label="Search for Documents..."
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          onChange={onChangeSearchHandller}
          variant="outlined"
          size="small"
          style={{height:"28.5px"}}
        />
        </Tooltip>
    </Grid>
  );
};

export default SearchDocuments;
